<template>
  <div v-if="userPermission">
    <b-form>
      <div>
        <b-tabs no-nav-style nav-class="secondary-tabs">
          <b-tab
            :title="$t('tabs.general')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(true)"
          >
            <user-form
              ref="form"
              @companiesInfo="getCompaniesInfo"
              :viewIsLoading="loading"
            />
          </b-tab>
          <edit-actions
            route-name="usersList"
            :is-visible-submit="isVisibleSubmit"
            @save="localSubmit"
          />
        </b-tabs>
      </div>
    </b-form>
  </div>
  <div
    v-else
    class="w-100 h-100 d-flex align-items-center justify-content-center"
  >
    <p class="fs-18 font-weight-bold">
      {{ $t("messages.dont_have_permission") }}
    </p>
  </div>
</template>

<script>
import userForm from '@/components/users/form'
import editActions from '@/components/common/editActions'
import model from '@/models/users'
import edit from '@/mixins/edit'
import permissions from '@/mixins/permissions'
import api from '@/api/users'

export default {
  components: {
    userForm,
    editActions
  },
  mixins: [edit, permissions],
  data: () => ({
    api,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true,
    companies: [],
    loading: false
  }),
  created() {
    this.init()
  },
  async mounted() {
    // Needed when creating a new user.
    await this.$refs.form?.init()
  },
  methods: {
    async init() {
      this.loading = true

      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }

      // Needed when editing an existing user.
      await this.$refs.form?.init()

      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    },
    async localSubmit() {
      const submitResponse = await this.submit()

      if (
        submitResponse.length === 0 &&
        this.$auth.user().id === parseInt(this.$route.params.id)
      ) {
        this.$auth.user().companies = this.companies
        this.$auth.user().name = this.item.name
        this.$auth.user().email = this.item.email
        this.$auth.user().department = this.item.department
        this.$auth.user().roles = this.item.roles
        this.$auth.user().file = this.item.file
      }
    },
    getCompaniesInfo(data) {
      this.companies = data
    }
  },
  validations: {
    ...model.rules
  }
}
</script>
